import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

const InfoCard = ({ title, description }) => {
  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        padding: "24px",
        backgroundColor: "#fff",
        height: { xs: "auto", sm: "auto", md: "305px", lg: "240px" },
      }}
    >
      <Typography
        sx={{
          fontWeight: "700",
          mb: "24px",
          fontSize: "24px",
          color: "#1D1E21",
          lineHeight: "24px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: "500",
          mb: 1,
          fontSize: "16px",
          color: "#3C3E44",
          lineHeight: { xs: "normal", lg: "24px" },
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

const VisionMissionSection = ({ cards = [] }) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const titles = [t("missed.Mission"), t("missed.Vision")];

  return (
    <Container maxWidth="lg">
      <Grid container spacing={2} sx={{ pb: "88px" }}>
        {cards.map((card, index) => (
          <Grid item xs={12} md={6} key={index}>
            <InfoCard
              title={titles[index] || t("Default Title")}
              description={card.description[currentLang]}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default VisionMissionSection;
